// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import Tdg_CompanyUpdateModel from '../../model/tdg-company-update-model';
import Tdg_CompanyUpdateDTO from '../dto/tdg-company-update-dto';
import dtoSchema from '../schemas/tdg-company-update-schema';
import ResourceLinkModel from '../../model/resource-link-model';
import LocationModel from '../../model/location-model';

export default abstract class Tdg_CompanyUpdateModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<Tdg_CompanyUpdateDTO>) {
    super();
    if (data) {
      this.id = data.id;
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.creatorId = data.creatorId;
      this.creatorName = data.creatorName ?? undefined;
      this.created = data.created;
      this.modifierId = data.modifierId ?? undefined;
      this.modifierName = data.modifierName ?? undefined;
      this.modified = data.modified ?? undefined;
      this.companyName = data.companyName;
      this.externalId = data.externalId;
      this.logoDocumentId = data.logoDocumentId ?? undefined;
      this.description = data.description ?? undefined;
      this.website = data.website ?? undefined;
      this.employeesCount = data.employeesCount ?? undefined;
      this.apprenticesCount = data.apprenticesCount ?? undefined;
      this.apprenticeShipsCount = data.apprenticeShipsCount ?? undefined;
      this.professionIds = data.professionIds;
      this.companyContactSalutation = data.companyContactSalutation;
      this.companyContactFirstName = data.companyContactFirstName;
      this.companyContactLastName = data.companyContactLastName;
      this.companyContactPhoneNumber = data.companyContactPhoneNumber;
      this.companyContactEmail = data.companyContactEmail;
      this.companyStreet = data.companyStreet;
      this.companyHouseNumber = data.companyHouseNumber ?? undefined;
      this.companyZIP = data.companyZIP;
      this.companyCity = data.companyCity;
      this.companyLocation = LocationModel.toModel(data.companyLocation);
      this.acceptConditions = data.acceptConditions;
      this.companyUserId = data.companyUserId ?? undefined;
      this.logoDocumentExternalId = data.logoDocumentExternalId ?? undefined;
      this.organisationExternalId = data.organisationExternalId ?? undefined;
      this.userName = data.userName ?? undefined;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;
  /**
  */
  links?: ResourceLinkModel[];
  /**
  * @type {int64}
  */
  creatorId?: number;
  /**
  */
  creatorName?: string;
  /**
  * @type {date-time}
  */
  created?: string;
  /**
  * @type {int64}
  */
  modifierId?: number;
  /**
  */
  modifierName?: string;
  /**
  * @type {date-time}
  */
  modified?: string;
  /**
  * @minimum 1
  */
  companyName?: string;
  /**
  * @type {uuid}
  */
  externalId?: string;
  /**
  * @type {int64}
  */
  logoDocumentId?: number;
  /**
  */
  description?: string;
  /**
  */
  website?: string;
  /**
  * @type {int32}
  */
  employeesCount?: number;
  /**
  * @type {int32}
  */
  apprenticesCount?: number;
  /**
  * @type {int32}
  */
  apprenticeShipsCount?: number;
  /**
  */
  professionIds?: number[];
  /**
  * @type {int32}
  */
  companyContactSalutation?: 0 | 1 | 2; // SalutationDTO
  /**
  * @minimum 1
  */
  companyContactFirstName?: string;
  /**
  * @minimum 1
  */
  companyContactLastName?: string;
  /**
  * @minimum 1
  */
  companyContactPhoneNumber?: string;
  /**
  * @minimum 1
  */
  companyContactEmail?: string;
  /**
  * @minimum 1
  */
  companyStreet?: string;
  /**
  */
  companyHouseNumber?: string;
  /**
  * @minimum 1
  */
  companyZIP?: string;
  /**
  * @minimum 1
  */
  companyCity?: string;
  /**
  */
  companyLocation?: LocationModel;
  /**
  */
  acceptConditions?: boolean;
  /**
  * @type {int64}
  */
  companyUserId?: number;
  /**
  */
  logoDocumentExternalId?: string;
  /**
  * @type {uuid}
  */
  organisationExternalId?: string;
  /**
  */
  userName?: string;

  static toModel(dto: DeepPartial<Tdg_CompanyUpdateDTO>): Tdg_CompanyUpdateModel;
  static toModel(dto: DeepPartial<Tdg_CompanyUpdateDTO> | undefined | null): Tdg_CompanyUpdateModel | undefined;
  static toModel(dto: DeepPartial<Tdg_CompanyUpdateDTO> | undefined | null): Tdg_CompanyUpdateModel | undefined {
    return dto ? new Tdg_CompanyUpdateModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<Tdg_CompanyUpdateModel> | Tdg_CompanyUpdateModel): Tdg_CompanyUpdateDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
      links: unwrapped.links,
      creatorId: unwrapped.creatorId,
      creatorName: unwrapped.creatorName,
      created: unwrapped.created,
      modifierId: unwrapped.modifierId,
      modifierName: unwrapped.modifierName,
      modified: unwrapped.modified,
      companyName: unwrapped.companyName,
      externalId: unwrapped.externalId,
      logoDocumentId: unwrapped.logoDocumentId,
      description: unwrapped.description,
      website: unwrapped.website,
      employeesCount: unwrapped.employeesCount,
      apprenticesCount: unwrapped.apprenticesCount,
      apprenticeShipsCount: unwrapped.apprenticeShipsCount,
      professionIds: unwrapped.professionIds,
      companyContactSalutation: unwrapped.companyContactSalutation,
      companyContactFirstName: unwrapped.companyContactFirstName,
      companyContactLastName: unwrapped.companyContactLastName,
      companyContactPhoneNumber: unwrapped.companyContactPhoneNumber,
      companyContactEmail: unwrapped.companyContactEmail,
      companyStreet: unwrapped.companyStreet,
      companyHouseNumber: unwrapped.companyHouseNumber,
      companyZIP: unwrapped.companyZIP,
      companyCity: unwrapped.companyCity,
      companyLocation: unwrapped.companyLocation,
      acceptConditions: unwrapped.acceptConditions,
      companyUserId: unwrapped.companyUserId,
      logoDocumentExternalId: unwrapped.logoDocumentExternalId,
      organisationExternalId: unwrapped.organisationExternalId,
      userName: unwrapped.userName,
    } as Tdg_CompanyUpdateDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for Tdg_CompanyUpdateModel, can not map to Tdg_CompanyUpdateDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
